export var ComplianceProfileRuleType;
(function (ComplianceProfileRuleType) {
    ComplianceProfileRuleType["BASE_RULES"] = "BASE_RULES";
    ComplianceProfileRuleType["CONDITIONAL_RULES"] = "CONDITIONAL_RULES";
    ComplianceProfileRuleType["MITCHELL_RULES"] = "MITCHELL_RULES";
})(ComplianceProfileRuleType || (ComplianceProfileRuleType = {}));
export var ComplianceProfileRuleSeverity;
(function (ComplianceProfileRuleSeverity) {
    ComplianceProfileRuleSeverity["REQUIRED"] = "REQUIRED";
    ComplianceProfileRuleSeverity["CRITICAL"] = "CRITICAL";
    ComplianceProfileRuleSeverity["OPTIONAL"] = "OPTIONAL";
})(ComplianceProfileRuleSeverity || (ComplianceProfileRuleSeverity = {}));
export var ComplianceProfileReviewerOption;
(function (ComplianceProfileReviewerOption) {
    ComplianceProfileReviewerOption["HIDDEN"] = "HIDDEN";
    ComplianceProfileReviewerOption["ESCALATED"] = "ESCALATED";
})(ComplianceProfileReviewerOption || (ComplianceProfileReviewerOption = {}));
export var ComplianceProfileRuleEstimateVersion;
(function (ComplianceProfileRuleEstimateVersion) {
    ComplianceProfileRuleEstimateVersion["ALL_VERSIONS"] = "ALL_VERSIONS";
    ComplianceProfileRuleEstimateVersion["ORIGINAL"] = "ORIGINAL";
    ComplianceProfileRuleEstimateVersion["ALL_SUPPLEMENTS"] = "ALL_SUPPLEMENTS";
    ComplianceProfileRuleEstimateVersion["SUPPLEMENT_2"] = "SUPPLEMENT_2+";
    ComplianceProfileRuleEstimateVersion["SUPPLEMENT_3"] = "SUPPLEMENT_3+";
    ComplianceProfileRuleEstimateVersion["SUPPLEMENT_4"] = "SUPPLEMENT_4+";
    ComplianceProfileRuleEstimateVersion["SUPPLEMENT_5"] = "SUPPLEMENT_5+";
})(ComplianceProfileRuleEstimateVersion || (ComplianceProfileRuleEstimateVersion = {}));
//# sourceMappingURL=ComplianceProfileRuleType.js.map